import Highcharts from "highcharts";

export const DarkTheme: Highcharts.Options | any = {
  global: { useUTC: false },
  colors: [
    "#1CA7EC",
    "#ff0066",
    "#DDDF0D",
    "#55BF3B",
    "#DF5353",
    "#7798BF",
    "#aaeeee"
  ],
  chart: {
    style: {
      fontFamily: "'Prompt'"
    },
    backgroundColor: {
      linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
      stops: [[0, "#2a2a2b"], [1, "#3e3e40"]]
    }
  },
  credits: {
    enabled: false
  },
  title: {
    style: {
      color: "white"
    }
  },
  subtitle: {
    style: {
      color: "white"
    }
  },
  xAxis: {
    // gridLineWidth: 0,
    // gridLineColor: "#444444",
    labels: {
      style: {
        color: "#fff"
      }
    }
  },
  yAxis: {
    gridLineWidth: 0,
    // gridLineColor: "#444444",
    labels: {
      style: {
        color: "#fff"
      }
    }
  },
  plotOptions: {
    series: {
      //   lineWidth: 5,
      shadow: { width: 15, opacity: 0.1, color: "rgba(255, 255, 255, 0.2)" }
    }
  },
  tooltip: {
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    style: {
      color: "#F0F0F0"
    }
  },
  legend: {
    itemStyle: {
      color: "#E0E0E3"
    },
    itemHoverStyle: {
      color: "#FFF"
    },
    itemHiddenStyle: {
      color: "#606063"
    }
  }
};
